export default {
    name: 'ToastNotification',
    data() {
        return {
            windowWidth: window.innerWidth
        }
    },
    computed: {
        isMobile() {
            let isMobile = false;
            if (this.windowWidth <= 767) {
                isMobile = true;
            }
            return isMobile;
        }
    },
    created() {
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        }
    }
}